import {
  Box,
  Grid,
  Typography,
  TextField,
  Link,
} from "@mui/material";
import styles from "../InternalTracker.module.css";
import RootComponents from "../../../components/common/RootComponents";
import { IoIosArrowRoundForward } from "react-icons/io";
import { useLocation, useNavigate } from "react-router-dom";
import { PiMapPinSimpleLineLight } from "react-icons/pi";
import { PiBuildingOfficeLight } from "react-icons/pi";
import { PiUserLight } from "react-icons/pi";
import { IoIosArrowRoundBack } from "react-icons/io";
import { IoIosAdd } from "react-icons/io";
import { useState } from "react";

const fieldStyle = {
  width: "100%",
  "& .MuiInputBase-root": {
    paddingLeft: "30px", // Adjust padding to make space for the icon
  },
  "& .MuiInputLabel-root": {
    left: "35px",
    fontSize: "14px ", // Adjust label position to align with input text
  },
  "& .MuiInputBase-input": {
    paddingBottom: "7px", // Add padding to the input text itself to make space for the icon
  },
  "& .MuiInputLabel-shrink": {
    left: "35px",
    fontSize: "14px", // Adjust label position when it shrinks
  },
  padding: "7px",
};

const InternalTrackerExperience = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { row } = location.state || {};
  const { formik1 } = location.state || {};
  const { selectedFileName } = location.state || {};
  const [showMore, setShowMore] = useState(false);

  const handleToggle = () => {
    setShowMore(!showMore);
  };

  return (
    // <RootComponents>
      <Box className={styles.add_structure}>
        <Typography className={styles.add_heading}>
          <b>Add More Experience</b> <IoIosAdd style={{ fontSize: "25px" }} />
        </Typography>

        <Grid container className={styles.candidate_field_section}>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            sx={{ padding: "5px 10px 0 10px", position: "relative" }}
          >
            <Box className={styles.icon_style}>
              <PiUserLight style={{ fontSize: "25px" }} />
            </Box>
            <TextField
              id="standard-basic"
              label="Role"
              variant="standard"
              name="full_name"
              sx={fieldStyle}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            sx={{ padding: "5px 10px 0 10px", position: "relative" }}
          >
            <Box
              className={styles.icon_style}
              sx={{ transform: "translateY(-50%) !important" }}
            >
              <PiBuildingOfficeLight style={{ fontSize: "25px" }} />
            </Box>
            <TextField
              id="standard-basic"
              label="Organization"
              variant="standard"
              type="text"
              name="organization"
              sx={fieldStyle}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            sx={{ padding: "5px 10px 0 10px", position: "relative" }}
          >
            <Box className={styles.icon_style}>
              <PiMapPinSimpleLineLight style={{ fontSize: "25px" }} />
            </Box>
            <TextField
              id="standard-basic"
              label="Location"
              variant="standard"
              type="text"
              name="location"
              sx={fieldStyle}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            sx={{ padding: "5px 10px 0 10px", position: "relative" }}
          >
            <Box className={styles.icon_style}>
              <PiMapPinSimpleLineLight style={{ fontSize: "25px" }} />
            </Box>
            <TextField
              id="standard-basic"
              label="Duration"
              variant="standard"
              type="text"
              name="duration"
              sx={fieldStyle}
            />
          </Grid>
        </Grid>

        <Box className={styles.add_section}>
          <Box>
            <Typography>
              <b> Responsibilities</b>{" "}
            </Typography>
            <Typography sx={{ marginBottom: "0 !important" }}>
              {showMore ? (
                <>
                  Povital provides a highly recommended AI-powered search engine
                  that helps to get appropriate talent as per the job
                  requirements along with many AI filtrations behind the
                  requirement. Povital also offers manual searching according to
                  user preferences with a super easy and user-friendly interface
                  Povital also offers manual searching according to user
                  preferences with a super easy and user-friendly interface
                  <Link
                    className={styles.view_show_link}
                    onClick={handleToggle}
                  >
                    Show less
                  </Link>
                </>
              ) : (
                <>
                  Povital provides a highly recommended AI-powered search engine
                  that helps to get appropriate talent as per the job
                  requirements along with many AI filtrations behind the
                  requirement. Povital also offers manual searching according to
                  user preferences with a super easy and user-friendly interface
                  <Link
                    className={styles.view_show_link}
                    onClick={handleToggle}
                  >
                    Show more
                  </Link>
                </>
              )}
            </Typography>
          </Box>
        </Box>

        <Grid container className={styles.field_section}>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            sx={{ padding: "5px 10px 0 10px", position: "relative" }}
          >
            <Box className={styles.icon_style}>
              <PiUserLight style={{ fontSize: "25px" }} />
            </Box>
            <TextField
              id="standard-basic"
              label="Role"
              variant="standard"
              name="full_name"
              sx={fieldStyle}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            sx={{ padding: "5px 10px 0 10px", position: "relative" }}
          >
            <Box
              className={styles.icon_style}
              sx={{ transform: "translateY(-50%) !important" }}
            >
              <PiBuildingOfficeLight style={{ fontSize: "25px" }} />
            </Box>
            <TextField
              id="standard-basic"
              label="Organization"
              variant="standard"
              type="text"
              name="organization"
              sx={fieldStyle}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            sx={{ padding: "5px 10px 0 10px", position: "relative" }}
          >
            <Box className={styles.icon_style}>
              <PiMapPinSimpleLineLight style={{ fontSize: "25px" }} />
            </Box>
            <TextField
              id="standard-basic"
              label="Location"
              variant="standard"
              type="text"
              name="location"
              sx={fieldStyle}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            sx={{ padding: "5px 10px 0 10px", position: "relative" }}
          >
            <Box className={styles.icon_style}>
              <PiMapPinSimpleLineLight style={{ fontSize: "25px" }} />
            </Box>
            <TextField
              id="standard-basic"
              label="Duration"
              variant="standard"
              type="text"
              name="duration"
              sx={fieldStyle}
            />
          </Grid>
        </Grid>
        <Box className={styles.add_section}>
          <Box>
            <Typography>
              <b> Responsibilities</b>{" "}
            </Typography>
            <Typography sx={{ marginBottom: "0 !important" }}>
              {showMore ? (
                <>
                  Povital provides a highly recommended AI-powered search engine
                  that helps to get appropriate talent as per the job
                  requirements along with many AI filtrations behind the
                  requirement. Povital also offers manual searching according to
                  user preferences with a super easy and user-friendly interface
                  Povital also offers manual searching according to user
                  preferences with a super easy and user-friendly interface
                  <Link
                    className={styles.view_show_link}
                    onClick={handleToggle}
                  >
                    Show less
                  </Link>
                </>
              ) : (
                <>
                  Povital provides a highly recommended AI-powered search engine
                  that helps to get appropriate talent as per the job
                  requirements along with many AI filtrations behind the
                  requirement. Povital also offers manual searching according to
                  user preferences with a super easy and user-friendly interface
                  <Link
                    className={styles.view_show_link}
                    onClick={handleToggle}
                  >
                    Show more
                  </Link>
                </>
              )}
            </Typography>
          </Box>
        </Box>
        <Box className={styles.add_candidate_btns}>
          <Box className={styles.add_back_btns}>
            <button
              onClick={() => navigate(-1)}
              style={{
                border: "1.5px solid #4287f5",
                marginRight: "10px",
                padding: "4.5px 10px ",
              }}
            >
              <IoIosArrowRoundBack
                style={{ fontSize: "25px", color: "#4287f5" }}
              />
            </button>
          </Box>
          <button
            onClick={() => navigate("/internal-tracker-candidate", {
              state: { formik1: formik1, selectedFileName, row: row },
            })}
            style={{
              backgroundColor: "#3856a6 ",
              padding: "5.5px 5px 5.5px 10px ",
            }}
          >
            Next Please{" "}
            <IoIosArrowRoundForward
              style={{ fontSize: "25px", marginLeft: "5px" }}
            />
          </button>
        </Box>
      </Box>
    // </RootComponents>
  );
};

export default InternalTrackerExperience;